import { TextField, Button, Checkbox } from "@mui/material";
import { useState, useContext, useEffect } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom"; // useNavigateをインポート
import Nav from './../components/Nav';
import validator from 'validator';
import { imgPath, gasPath, TokenContext, isExpiry } from './../App';

const Login = () => {
  const token = useContext(TokenContext);

  const navigate = useNavigate();
  const today = dayjs();
  const minDate = today.subtract(100, "year"); // 100歳
  const maxDate = today.subtract(3, "year");   // 3歳
  const [userData, setUserData] = useState({ email: null, birthday: null })
  const [isFailed, setIsFailed] = useState(false);
  const [validateStatus, setValidateStatus] = useState({
    email: { valid: true, message: '' },
    birthday: { valid: true, message: '' },
  });
  const [register, setRegister] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    setValidateStatus({
      email: { valid: true, message: '' },
      birthday: { valid: true, message: '' },
    });
    setUserData({
      email: '',
      birthday: '',
    });
  }, [register]);

  const birthdayHandler = (date) => {
    const inputDate = dayjs(date);
    let val = { valid: true, message: '' };
    if (inputDate.isBefore(minDate) || inputDate.isAfter(maxDate)) {
      val = {
        valid: false,
        message: '年齢は3歳〜100歳の範囲で入力してください',
      };
    }

    setValidateStatus(prev => ({
      ...prev,
      birthday: val
    }));

    setUserData(prev => ({
      ...prev,
      birthday: inputDate.format('YYYY/MM/DD')
    }));
  };

  const emailHandler = (e) => {
    const email = e.target.value;
    const isValid = validator.isEmail(email);
    setValidateStatus(prev => ({
      ...prev,
      email: {
        valid: isValid,
        message: isValid ? '' : '有効なメールアドレスを入力してください',
      }
    }));
    setUserData(prev => ({ ...prev, email: email }));
  }

  const loginHander = () => {
    console.log(`login start`)
    setVerifying(true);
    setIsFailed(false);
    fetch(gasPath, {
      method: "POST",
      body: JSON.stringify({ ...userData, token: token }),
      headers: {
        'Content-Type': 'text/plain',
      }
    })
      .then(res => res.text())                     // レスポンス全体を文字列として取得
      .then(text => JSON.parse(text))
      .then(data => {
        console.log(data)
        if (register) {
          if (data.status === `success`) {
            sessionStorage.setItem("jacUserCore", JSON.stringify({
              email: userData.email,
            }));
            navigate('/register/');
            return;
          } else {
            setIsFailed(true);
          }
        } else {
          console.log(data);
          if (data?.userInfo) {
            const userInfo = data?.userInfo

            const expiry = dayjs(userInfo.expiry, 'YYYY/MM/DD', true);
            let membership;

            const daysUntilExpiry = expiry.diff(dayjs(), 'day');

            if (isExpiry(userInfo.expiry)) {
              membership = 'invalid';
            } else if ([`honorary`, `lifetime`].includes(userInfo.membership)) {
              membership = userInfo.membership;
            } else if (userInfo.corporateCode !== '') {
              membership = 'corporate';
            } else if (daysUntilExpiry >= 0 && (userInfo.membership === 'individual' || userInfo.paymentMethod === `paypal_subscription`)) {
              membership = 'individual';
            } else if (daysUntilExpiry >= 0 && (userInfo.membership === 'individual' || userInfo.paymentMethod === `end_paypal_subscription`)) {
              membership = 'individual';
            } else if (daysUntilExpiry >= 0 && (userInfo.membership === 'supporting' || userInfo.paymentMethod === `paypal`)) {
              membership = 'supporting';
            } else if (!userInfo.paymentDate && daysUntilExpiry >= 0 && daysUntilExpiry <= 7) {
              membership = 'temporary';
            }
            const userCore = {
              id: userInfo.id,
              expiry: userInfo.expiry,
              familyName: userInfo.familyName,
              middleName: userInfo.middleName,
              firstName: userInfo.firstName,
              familyNameEn: userInfo.familyNameEn,
              middleNameEn: userInfo.middleNameEn,
              firstNameEn: userInfo.firstNameEn,
              birthday: userInfo.birthday,
              email: userInfo.email,
              passportNo: userInfo.passportNo,
              passportExpiry: userInfo.passportExpiry,
              phonePh: userInfo.phonePh,
              phoneJa: userInfo.phoneJa,
              address: userInfo.address,
              job: userInfo.job,
              corporateCode: userInfo.corporateCode,
              visa: userInfo.visa,
              paymentDate: userInfo.paymentDate,
              emergencyContact: userInfo.emergencyContact,
              emergencyPerson: userInfo.emergencyPerson,
              unit: userInfo.unit,
              amount: userInfo.amount,
              quantity: userInfo.quantity,
              paymentMethod: userInfo.paymentMethod,
              orderId: userInfo.orderId,
              createTime: userInfo.createTime,
              paypalStatus: userInfo.paypalStatus,
              membership: membership
            };

            sessionStorage.setItem('jacUserCore', JSON.stringify(userCore));
            navigate('/user-info/');
          } else {
            setIsFailed(true);
          }
        }
        setVerifying(false);
      })
      .catch(err => {
        console.error("Error:", err)
        setVerifying(false);
      }
      );
  }


  return <>
    <Nav register={register} setRegister={setRegister} setUserData={setUserData}></Nav>
    {register && <p style={{ textAlign: `center`, marginBottom: `32px` }} >登録するメールアドレスを入力ください。</p>}
    <p style={{ paddingBottom: '12px' }}>
      <TextField
        label="メールアドレス"
        error={!validateStatus.email.valid}
        variant="outlined" sx={{ width: "100%" }}
        value={userData.email ?? ''}
        onInput={emailHandler} />
      {validateStatus.email.message !== '' &&
        <span className="error" >{validateStatus.email.message}</span>

      }
    </p>
    {
      !register &&
      <div style={{ paddingBottom: '12px' }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="生年月日"
            format="YYYY/MM/DD"
            error={!validateStatus.birthday.valid}
            minDate={minDate}
            maxDate={maxDate}
            value={dayjs(userData.birthday)}
            onChange={birthdayHandler}
            sx={{ width: "100%" }}
            slotProps={{
              textField: {
                error: userData.birthday === null || userData.birthday === '' ? false : undefined,
                helperText: userData.birthday === null ? '' || userData.birthday === '' : undefined,
              },
            }}
          />
        </LocalizationProvider>
        {validateStatus.birthday.message !== '' &&
          <span className="error" >{validateStatus.birthday.message}</span>
        }
      </div>
    }

    {
      register ? (isFailed && <p style={{
        color: `var(--red)`
      }} >このメールアドレスはすでに登録済みです。</p>)
        :
        (isFailed &&
          <p style={{
            color: `var(--red)`
          }} >
            ご入力いただいた情報では該当する会員が見つかりませんでした（メンバーシップ期限外の場合、データが取得できない場合があります）。<br />
            メールアドレスや生年月日の記憶に誤りがあるかもしれません。ご確認のうえ、それでも解決しない場合は<a href="/contact" target="_blank" style={{
              color: `var(--red)`
            }} >こちら</a>までお問い合わせください。
          </p>
        )
    }
    {register ?
      <>
        <p><Checkbox checked={isAgreed}
          onChange={(e) => setIsAgreed(e.target.checked)} /><a href="https://www.ja-cebu.com/constitution/" target="_blank" rel="noreferrer">セブ日本人会・会則</a>に同意の上、会員登録へお進みください。</p>
        <p style={{ textAlign: `right`, marginTop: `12px` }}>
          <Button
            style={{ background: `var(--blue)`, color: `#fff`, height: `50px`, fontSize: `20px` }}
            sx={{ width: "150px" }}
            onClick={loginHander}
            disabled={
              !userData.email ||
              !validateStatus.email.valid ||
              verifying ||
              !isAgreed
            }
          >次へ</Button>

        </p></> :
      <p style={{ textAlign: `center`, marginTop: `12px` }}>
        <Button
          style={{ background: `var(--blue)`, color: `#fff`, height: `50px`, fontSize: `20px` }}
          sx={{ width: "300px" }}
          onClick={loginHander}
          disabled={
            !userData.birthday ||
            !userData.email ||
            !validateStatus.email.valid ||
            !validateStatus.birthday.valid ||
            verifying
          }
        >ログイン</Button>

      </p>
    }
    {verifying && <div className="register"><img src={`${imgPath}/images/spinner.svg`} alt="" width={100} height={110} /></div>}
    {/* <div className="register"><img src={`${imgPath}/images/spinner.svg`} alt="" width={100} height={110} /></div> */}
  </>
}
export default Login;
